import React from 'react';
import PropTypes from 'prop-types';

import Ottercon from 'components/ottercon';

export default function FilesRow({ file, selected, onSelected }) {
  const handleChange = () => {
    onSelected(file.id);
  };

  return (
    <tr>
      <td className="auto-size">
        <input
          checked={selected}
          className="checkbox--lg"
          type="checkbox"
          onChange={handleChange}
        />
      </td>
      <td className="auto-size">
        <Ottercon ottercon={file.ottercon} size="xs" />
      </td>
      <td>{file.fileName}</td>
      <td>{file.fileType}</td>
    </tr>
  );
}

FilesRow.propTypes = {
  file: PropTypes.shape({
    id: PropTypes.number,
    fileName: PropTypes.string,
    fileType: PropTypes.string,
    ottercon: PropTypes.string
  }).isRequired,
  selected: PropTypes.bool.isRequired,
  onSelected: PropTypes.func.isRequired
};
